import React from 'react';
import { SERIES_COLORS } from './chartTheme';
import './DistributionBar.css';

export interface DistributionSegment {
  label: string;
  value: number;
  /** Formatted value for the legend (e.g. "$1,240"). */
  display: string;
}

interface DistributionBarProps {
  /** Segments in fixed order; >8 should be pre-folded into "Other". */
  segments: DistributionSegment[];
}

/**
 * Horizontal stacked bar for part-to-whole (never a pie). Legend carries
 * labels + values so identity is never color-alone, and 2px gaps separate
 * adjacent fills.
 */
const DistributionBar: React.FC<DistributionBarProps> = ({ segments }) => {
  const total = segments.reduce((acc, s) => acc + s.value, 0);
  if (total <= 0 || segments.length === 0) {
    return <p className="distribution-bar-empty">No data for this range.</p>;
  }
  return (
    <div className="distribution-bar">
      <div className="distribution-bar-track">
        {segments.map((segment, i) => (
          <div
            key={segment.label}
            className="distribution-bar-fill"
            style={{
              width: `${(segment.value / total) * 100}%`,
              background: SERIES_COLORS[i % SERIES_COLORS.length],
            }}
            title={`${segment.label}: ${segment.display}`}
          />
        ))}
      </div>
      <div className="distribution-bar-legend">
        {segments.map((segment, i) => (
          <span key={segment.label} className="distribution-bar-key">
            <span
              className="distribution-bar-swatch"
              style={{ background: SERIES_COLORS[i % SERIES_COLORS.length] }}
            />
            {segment.label}
            <span className="distribution-bar-value">
              {segment.display} ({Math.round((segment.value / total) * 100)}%)
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default DistributionBar;
